<template>
    <section id="testimonials" class="pt-md-5 pb-md-5 pt-3 pb-3 bg-top">
        <div class="container">
            <h2>We know our stuff</h2>

            <carousel
                ref="Carousel"
                :per-page-custom="[[340, 1], [768, 2], [992, 3]]"
                :scroll-per-page="false"
                :adjustable-height="false"
                :navigation-enabled="true"
                :pagination-enabled="false"
                navigation-prev-label=""
                navigation-next-label=""
                :center-mode="true"
                :loop="true">
                <slide>
                    <div class="card h-100">
                        <div class="card-img-top">
                            <figure>
                                <img src="../assets/partners/01.png" alt="">
                            </figure>
                        </div>
                        <div class="card-body">
                            <cite>"Working with the Empower team for more than 15 years! They have smart people and I trust them to help drive my business." - Alex Chew, Head of Partnerships at Jerry.ai</cite>
                        </div>
                    </div>
                </slide>

                <slide>
                    <div class="card h-100">
                        <div class="card-img-top">
                            <figure>
                                <img src="../assets/partners/02.png" alt="">
                            </figure>
                        </div>
                        <div class="card-body">
                            <cite>Empower Direct created campaigns with over 200,000 thousand unique book titles and authors, across multiple search engine platforms for Audiobooks.com, generating thousands of sign ups.</cite>
                        </div>
                    </div>
                </slide>

                <slide>
                    <div class="card h-100">
                        <div class="card-img-top">
                            <figure>
                                <img src="../assets/partners/03.png" alt="">
                            </figure>
                        </div>
                        <div class="card-body">
                            <cite>Empower Direct generated over 5.9 million new car purchase leads across more than 30 vehicle manufactures, supplying leads to over 39,000 dealers.</cite>
                        </div>
                    </div>
                </slide>

                <slide>
                    <div class="card h-100">
                        <div class="card-img-top">
                            <figure>
                                <img src="../assets/partners/04.png" alt="">
                            </figure>
                        </div>
                        <div class="card-body">
                            <cite>"Since the inception of our business, and the many following years, the team at Empower Direct has helped us develop, adjust, execute and hone our lead generation and marketing strategies." - Jason Goldsmith, CEO at CarChex</cite>
                        </div>
                    </div>
                </slide>

                <slide>
                    <div class="card h-100">
                        <div class="card-img-top">
                            <figure>
                                <img src="../assets/partners/05.png" alt="">
                            </figure>
                        </div>
                        <div class="card-body">
                            <cite>"Empower Direct has been a great partner in helping us search engine market our unique language learning tools to students all around the world. Their expertise is distinctly ahead of the various companies we have worked with in SEM." - Benjamin Levy, CEO at Gymglish</cite>
                        </div>
                    </div>
                </slide>
            </carousel>
        </div>
    </section>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: 'Testimonials',

        components: {
            Carousel,
            Slide,
        },
    };
</script>

<style lang="scss">
    @import '../scss/variables';

    #testimonials {
        .VueCarousel-wrapper {
            padding: 1rem 0;
            .VueCarousel-slide {
                padding: 0 15px;
            }
        }
        .card {
            box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);
            .card-img-top {
                padding-top: 1rem;
            }
            figure {
                text-align: center;
            }

            cite {
                font-weight: normal;
                @include font-size(18px);
                font-style: normal;
                color: $color_4;
            }
        }
        .VueCarousel-navigation {
            .VueCarousel-navigation-button {
                background-repeat: no-repeat;
                background-position: center center;
                background-size: contain;
                height: 40px;
                padding: 7px !important;
                &.VueCarousel-navigation-prev {
                    background-image: url('../assets/arrow-left.svg');
                }
                &.VueCarousel-navigation-next {
                    background-image: url('../assets/arrow-right.svg');
                }
            }
        }
    }
</style>
